// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Wx62k","button-animate":"Button_button-animate__tvido","button-tertiary":"Button_button-tertiary__iDiEh"};